var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDistributor)?_c('form-section',{attrs:{"headline":_vm.$t('form.goodwill.legend'),"id":"goodwill"}},[_c('text-field',{attrs:{"id":"goodwill_percent","label":_vm.$t('form.goodwill.goodwill_percent.label'),"placeholder":_vm.$t('form.goodwill.goodwill_percent.placeholder'),"isRequired":"","appendText":"%"},model:{value:(_vm.goodwillPercent),callback:function ($$v) {_vm.goodwillPercent=$$v},expression:"goodwillPercent"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/form/GoodwillInput.vue?vue&type=template&id=74c9ecc5&
// module id = null
// module chunks = 